/* eslint-disable */
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React, { Component } from "react";
import { Icon } from "office-ui-fabric-react";
import ModalComponent from "../ModalComponent/ModalComponent";

import "./FRESplash.scss";

export class FRESplash extends Component { 
  totalCarouselPages = 3;

  constructor(props) {
    super(props);
    this.state = {carouselPage: props.frePage, pageSlideDirection: 'left', burning: true};
  }

  setCarouselPage = i => {
    this.setState({carouselPage: i, pageSlideDirection: this.state.carouselPage < i ? 'left' : (this.state.carouselPage === i ? '' : 'right'), burning: false});
  }

    generateDots = () => {
        let dots = [];
        for(var i = 0; i < this.totalCarouselPages; i++){
            dots.push(i);
        }
        dots = dots.map(i => <div key={i} onClick={() => this.setCarouselPage(i)} className={`dot ${this.state.carouselPage === i ? 'filled' : ''}`}></div>);
        return dots;
    }

    getCarouselPages = () => {
        let page1 = <div key={0} className={`page ${this.state.pageSlideDirection} ${this.state.carouselPage === 0 ? 'shown' : ''}`}>
            <div className='page1img'></div> 
            <div className='text'>Welcome to the Azure Digital Twins Explorer! We have a lot of great features and capabilities to help you manage and understand your Azure Digital Twins environment.</div>
        </div>;
        let page2 = <div key={1} className={`page page2 ${this.state.pageSlideDirection} ${this.state.carouselPage === 1 ? 'shown' : ''}`}>
            <div className='page2img'></div>
            <div className='text'>The Azure Digital Twins Explorer lets you explore the Azure Digital Twins APIs in an intuitive, visual tool. Query your twins graph, manage your models, and learn about the service from the comfort of your browser.</div>
        </div>;
        let page3 = <div key={2} className={`page page3 ${this.state.pageSlideDirection} ${this.state.carouselPage === 2 ? 'shown' : ''}`}>
            <div className='images'>
                <div className='page3imgaWrapper' onClick={() => window.open('https://docs.microsoft.com/azure/digital-twins/quickstart-azure-digital-twins-explorer')}>
                    <div className='page3aimg'></div>
                    <div className='text'>Check out a sample scenario quickstart</div>
                </div>
                <div className='page3imgbWrapper' onClick={() => window.open('https://aka.ms/learnadtexplorer')}>
                    <div className='page3bimg'></div>
                    <div className='text'>Watch a video illustrating the features of the Explorer</div>
                </div>
            </div>
            <div className='text'>To learn more, check out these links to help you get started.</div>
        </div>;
        return [page1, page2, page3];
    }

  render() {
      return <ModalComponent
        isVisible={true}
        className="fre-splash">
            <div className='carousel'>
                {this.state.carouselPage !== 0 && <button onClick={() => {this.setCarouselPage(this.state.carouselPage - 1)}} className='leftButton'>
                    <Icon
                    iconName="ChevronLeft" />
                </button>}
                {this.state.carouselPage !== this.totalCarouselPages - 1 && <button onClick={() => {this.setCarouselPage(this.state.carouselPage + 1)}} className='rightButton'>
                    <Icon
                    iconName="ChevronRight" />
                </button>}
                {this.getCarouselPages()}
                <div className='dots'>
                    {this.generateDots()}
                </div>
                <button onClick={this.props.close} className="fre-close">
                    <Icon
                    iconName="ChromeClose" />
                </button>
            </div>
    </ModalComponent>
  }
}